// apps/buildlog/src/components/LoadingScreen.tsx
export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-brand-slate flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-brand-blue border-t-transparent mb-4"></div>
        <p className="text-brand-blue font-display text-xl">Loading...</p>
      </div>
    </div>
  );
}